export default "__VITE_ASSET__74532fad__"